/* unplugin-vue-components disabled */import script from "./LicenseFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./LicenseFooter.vue?vue&type=script&setup=true&lang=js"

import "./LicenseFooter.vue?vue&type=style&index=0&id=32fc6713&lang=less"

const __exports__ = script;

export default __exports__